const MMReviewsManager = {
	config: {
		selectors: {
			splide: '.mm-reviews__splide',
			jdgmWrapper: '.mm-reviews__jdgm-wrapper',
			jdgmAvgTarget: '.mm-reviews__jdgm-average',
		},
	},

	init() {
		/* Mode blocks manuels : init Splide */
		document.querySelectorAll(this.config.selectors.splide).forEach(function (el) {
			if (typeof Splide === 'undefined') return;

			/* Guard : évite un double mount (clones dupliqués). Ce slider est géré ici :
			   on détruit l'instance du SplideManager global (mm_components.js) ou d'une
			   exécution précédente (shopify:section:load), et on partage la même propriété
			   _splide pour que le SplideManager ne le remonte pas s'il passe après */
			if (el._splide) {
				el._splide.destroy(true);
				/* Le SplideManager masque les flèches en inline : la visibilité est gérée en CSS ici */
				const arrows = el.querySelector('.splide__arrows');
				if (arrows) arrows.style.removeProperty('visibility');
			}

			const splide = new Splide(el);
			el._splide = splide;

			/* Loop : Splide clone les slides même quand elles tiennent toutes à l'écran
			   (ex: 1 seul avis affiché en double) — pas de clones ni de drag sans débordement.
			   Les flèches sont masquées en CSS via .is-overflow */
			splide.on('overflow', function (isOverflow) {
				splide.go(0);
				splide.options = {
					drag: isOverflow,
					clones: isOverflow ? undefined : 0,
				};
			});

			splide.mount();
		});

		/* Mode app (Judge.me) */
		const jdgmWrapper = document.querySelector(this.config.selectors.jdgmWrapper);
		if (!jdgmWrapper) return;

		/* Attendre que JM ait rendu le carousel ET les étoiles des cartes */
		const observer = new MutationObserver((mutations, obs) => {
			const headerInfo = jdgmWrapper.querySelector('.jdgm-header-info');
			const firstCardStar = jdgmWrapper.querySelector(
				'.jdgm-carousel-item:not(.jdgm-clone-before):not(.jdgm-clone-after) .jdgm-star.jdgm--on'
			);
			if (headerInfo && firstCardStar) {
				obs.disconnect();
				this._injectAverageRating(jdgmWrapper, headerInfo);
				this._fillDistribution(jdgmWrapper);
				this._fixStarColors(jdgmWrapper);
				this._injectArrowIcons(jdgmWrapper);
				this._initJdgmSwipe(jdgmWrapper);

				/* Re-fixer les couleurs si JM re-render */
				const colorObserver = new MutationObserver(() => this._fixStarColors(jdgmWrapper));
				colorObserver.observe(jdgmWrapper, { subtree: true, attributes: true, attributeFilter: ['style'] });
			}
		});
		observer.observe(jdgmWrapper, { childList: true, subtree: true });

		/* Si déjà rendu avec étoiles */
		const existingHeader = jdgmWrapper.querySelector('.jdgm-header-info');
		const existingStar = jdgmWrapper.querySelector(
			'.jdgm-carousel-item:not(.jdgm-clone-before):not(.jdgm-clone-after) .jdgm-star.jdgm--on'
		);
		if (existingHeader && existingStar) {
			observer.disconnect();
			this._injectAverageRating(jdgmWrapper, existingHeader);
			this._fillDistribution(jdgmWrapper);
			this._fixStarColors(jdgmWrapper);
			this._injectArrowIcons(jdgmWrapper);
			this._initJdgmSwipe(jdgmWrapper);
		}
	},

	/* Reconstruire le rating summary dans notre zone avec des SVG stars MM */
	_injectAverageRating(wrapper, headerInfo) {
		const target = document.querySelector(this.config.selectors.jdgmAvgTarget);
		if (!target || target.children.length > 0) return;

		const ratingText = headerInfo.querySelector('.jdgm-rating-text');
		const reviewsCount = headerInfo.querySelector('.jdgm-reviews-count');
		if (!ratingText) return;

		/* Extraire la note numérique (ex: "4.60") */
		const ratingMatch = ratingText.textContent.trim().match(/^(\d+[\.,]\d+)/);
		const rating = ratingMatch ? parseFloat(ratingMatch[1]) : null;
		const count = reviewsCount ? reviewsCount.textContent.trim() : null;

		if (!rating) return;

		const starSVG = (filled) => `<svg class="mm-reviews__star-icon${filled ? '' : ' mm-reviews__star-icon--off'}" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 1.5L9.85 5.5L14.25 6.15L11.25 9L12 13.4L8 11.35L4 13.4L4.75 9L1.75 6.15L6.15 5.5L8 1.5Z"/></svg>`;

		let starsHTML = '';
		for (let i = 1; i <= 5; i++) {
			starsHTML += starSVG(i <= Math.round(rating));
		}

		target.innerHTML = `
			<div class="mm-reviews__stars" aria-label="${rating} étoiles sur 5" role="img">${starsHTML}</div>
			<div class="mm-reviews__rating-value">${rating.toFixed(1)} / 5</div>
			${count ? `<div class="mm-reviews__rating-count">${count} avis</div>` : ''}
		`;
	},

	/* Remplir les barres de distribution depuis les cartes JM du carousel */
	_fillDistribution(wrapper) {
		/* Chercher la distribution dans la même section parente que le wrapper JM */
		const section = wrapper.closest('.mm-reviews');
		const distSection = section ? section.querySelector('.mm-reviews__distribution') : null;
		if (!distSection) return;

		/* Ne remplir que si le Liquid a signalé l'absence de données manuelles */
		if (!distSection.dataset.jdgmAuto) return;

		/* Compter les étoiles par carte (clones exclus) */
		const cards = wrapper.querySelectorAll(
			'.jdgm-carousel-item:not(.jdgm-clone-before):not(.jdgm-clone-after)'
		);
		const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
		cards.forEach(function (card) {
			const on = card.querySelectorAll('.jdgm-star.jdgm--on').length;
			const half = card.querySelectorAll('.jdgm-star.jdgm--half').length;
			const rating = Math.round(on + (half > 0 ? 0.5 : 0));
			if (rating >= 1 && rating <= 5) counts[rating]++;
		});

		const total = cards.length;
		if (total === 0) return;

		/* Mettre à jour chaque barre */
		for (let star = 5; star >= 1; star--) {
			const row = distSection.querySelector(
				`.mm-reviews__bar-row:nth-child(${6 - star})`
			);
			if (!row) continue;

			const fill = row.querySelector('.mm-reviews__bar-fill');
			const countEl = row.querySelector('.mm-reviews__bar-count');
			const pct = Math.round((counts[star] / total) * 100);

			if (fill) fill.style.width = pct + '%';
			if (countEl) countEl.textContent = counts[star];
		}
	},

	/* Swipe touch + drag souris sur le carousel JM (pas de support natif) */
	_initJdgmSwipe(wrapper) {
		const carousel = wrapper.querySelector('.jdgm-cards-carousel');
		if (!carousel) return;

		/* L'ID JM est dans le onclick des boutons flèches — on le lit même si les boutons sont cachés */
		var carouselId = null;
		wrapper.querySelectorAll('.jdgm-arrow').forEach(function (btn) {
			var match = (btn.getAttribute('onclick') || '').match(/jdgm(?:Next|Previous)Card\('([^']+)'\)/);
			if (match) carouselId = match[1];
		});
		if (!carouselId) return;

		var threshold = 50;
		var startX = 0;
		var isDragging = false;

		function resolveSwipe(diff) {
			if (Math.abs(diff) < threshold) return;
			if (diff > 0) {
				window.jdgmNextCard(carouselId);
			} else {
				window.jdgmPreviousCard(carouselId);
			}
		}

		carousel.addEventListener('touchstart', function (e) {
			startX = e.touches[0].clientX;
		}, { passive: true });

		carousel.addEventListener('touchend', function (e) {
			resolveSwipe(startX - e.changedTouches[0].clientX);
		}, { passive: true });

		/* Drag souris/trackpad (desktop) */
		carousel.addEventListener('mousedown', function (e) {
			isDragging = true;
			startX = e.clientX;
			carousel.classList.add('mm-reviews__jdgm-dragging');
		});

		carousel.addEventListener('mousemove', function (e) {
			if (!isDragging) return;
			e.preventDefault();
		});

		carousel.addEventListener('mouseup', function (e) {
			if (!isDragging) return;
			isDragging = false;
			carousel.classList.remove('mm-reviews__jdgm-dragging');
			resolveSwipe(startX - e.clientX);
		});

		carousel.addEventListener('mouseleave', function () {
			isDragging = false;
			carousel.classList.remove('mm-reviews__jdgm-dragging');
		});
	},

	/* Remplacer les SVG natifs JM par nos chevrons MM */
	_injectArrowIcons(wrapper) {
		const chevronLeft = '<svg class="mm-flex mm-reviews__arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M11 2L5 8L11 14" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
		const chevronRight = '<svg class="mm-flex mm-reviews__arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M3.75 10.5L8.25 6L3.75 1.5" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';

		const arrows = wrapper.querySelectorAll('.jdgm-arrow');
		arrows.forEach(function (arrow) {
			if (arrow.querySelector('.mm-reviews__arrow-icon')) return;
			const isPrev = arrow.getAttribute('aria-label') && arrow.getAttribute('aria-label').toLowerCase().includes('previous');
			arrow.insertAdjacentHTML('beforeend', isPrev ? chevronLeft : chevronRight);
		});
	},

	/* Les étoiles JM ont un style inline color — on force via JS */
	_fixStarColors(wrapper) {
		const root = document.documentElement;
		const colorOn = getComputedStyle(root).getPropertyValue('--ratings').trim() || 'rgba(255,165,0,1)';
		const colorOff = getComputedStyle(root).getPropertyValue('--border-light').trim() || '#E0E0E0';

		wrapper.querySelectorAll('.jdgm-star').forEach(function (star) {
			if (star.classList.contains('jdgm--on') || star.classList.contains('jdgm--half')) {
				star.style.setProperty('color', colorOn, 'important');
			} else if (star.classList.contains('jdgm--off')) {
				star.style.setProperty('color', colorOff, 'important');
			}
		});

		/* Fixer aussi les étoiles dans notre zone summary clonée */
		const avgTarget = document.querySelector(MMReviewsManager.config.selectors.jdgmAvgTarget);
		if (avgTarget) {
			avgTarget.querySelectorAll('.jdgm-star').forEach(function (star) {
				if (star.classList.contains('jdgm--on') || star.classList.contains('jdgm--half')) {
					star.style.setProperty('color', colorOn, 'important');
				} else if (star.classList.contains('jdgm--off')) {
					star.style.setProperty('color', colorOff, 'important');
				}
			});
		}
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => MMReviewsManager.init());
} else {
	MMReviewsManager.init();
}